import { OrmModel } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import Counter from '@/data/models/tables/Counter'

@OrmModel(modelNames.REJECTED_SMS_COUNTER)
export default class RejectedSmsCounter extends Counter {}
